import { api } from '@services';

import Update, {
  IUpdateRawQueryList,
  IUpdateRawQueryListApiModel,
} from '@models/Update.model';

const getUpdateRaw = async (id: string): Promise<IUpdateRawQueryList> => {
  const { data: update } = await api.get<IUpdateRawQueryListApiModel>(
    `/updates/${id}/raw`,
  );
  return Update.fromRawQueryListApiModel(update);
};

export { getUpdateRaw };
